<div class="container">
  <h2 class="font-bold m-4">Add User Roles and Permissions ...</h2>
  <div class="col-md-12 mb-4">
    <div class="user-profile-card">
      <div class="user-profile-card__header">
        <img class="user-profile-card__avatar" [src]="md.profileImages || 'assets/images/userbig.png'" alt="{{md.userName}}">
        <div class="user-profile-card__identity">
          <h3 class="user-profile-card__name">{{md.userName}}</h3>
          <span class="user-profile-card__subtitle">
            {{md.jobtitle}}<ng-container *ngIf="md.jobtitle && md.department"> &middot; </ng-container>{{md.department}}
          </span>
        </div>
      </div>
      <div class="user-profile-card__details">
        <div class="user-profile-card__item">
          <mat-icon>email</mat-icon>
          <div class="user-profile-card__text">
            <span class="user-profile-card__label">Email</span>
            <span class="user-profile-card__value">{{md.email}}</span>
          </div>
        </div>
        <div class="user-profile-card__item">
          <mat-icon>phone</mat-icon>
          <div class="user-profile-card__text">
            <span class="user-profile-card__label">Mobile</span>
            <span class="user-profile-card__value">{{md.mobile}}</span>
          </div>
        </div>
        <div class="user-profile-card__item">
          <mat-icon>place</mat-icon>
          <div class="user-profile-card__text">
            <span class="user-profile-card__label">Location</span>
            <span class="user-profile-card__value">{{md.location}}</span>
          </div>
        </div>
        <div class="user-profile-card__item">
          <mat-icon>apartment</mat-icon>
          <div class="user-profile-card__text">
            <span class="user-profile-card__label">Department</span>
            <span class="user-profile-card__value">{{md.department}}</span>
          </div>
        </div>
        <div class="user-profile-card__item">
          <mat-icon>badge</mat-icon>
          <div class="user-profile-card__text">
            <span class="user-profile-card__label">Job Title</span>
            <span class="user-profile-card__value">{{md.jobtitle}}</span>
          </div>
        </div>
        <div class="user-profile-card__item" *ngIf="md.vehicleNo">
          <mat-icon>directions_car</mat-icon>
          <div class="user-profile-card__text">
            <span class="user-profile-card__label">Vehicle Number</span>
            <span class="user-profile-card__value">{{md.vehicleNo}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <button mat-raised-button color="primary" (click)="AddFunction(md.uid,data)">
      Add Role Permission
    </button>
  </div>
  <div class="row">
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Select Role</mat-label>
      <mat-select [ngModel]="roleSelected" (selectionChange)="onRoleSelect($event)">
        <mat-option *ngFor="let u of roles$|async" [value]="u.id">{{u.id}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-8">
      <mat-label>Select Centres</mat-label>
      <mat-select [(value)]="selectedCentres" multiple>
        <mat-select-trigger>
          {{selectedCentres?.[0] || ''}}
          <span *ngIf="(selectedCentres?.length || 0) > 1" class="text-secondary opacity-75 text-sm">
            (+{{(selectedCentres?.length || 0) - 1}} {{(selectedCentres?.length || 0) === 2 ? 'other' : 'others'}})
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let c of centres" [value]="c">{{c}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="roleSelected === 'Driver'" appearance="outline" class="col-md-12 mt-3">
      <mat-label>Select Vehicles</mat-label>
      <mat-select [(value)]="selectedVehicles" multiple>
        <mat-select-trigger>
          {{selectedVehicles?.[0] || ''}}
          <span *ngIf="(selectedVehicles?.length || 0) > 1" class="text-secondary opacity-75 text-sm">
            (+{{(selectedVehicles?.length || 0) - 1}} {{(selectedVehicles?.length || 0) === 2 ? 'other' : 'others'}})
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let v of vehicles$ | async" [value]="v.vehicleNumber">{{v.vehicleName}} ({{v.vehicleNumber}})</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="col-md-12 mt-3">
      <mat-checkbox [(ngModel)]="isDepartmentHead" [ngModelOptions]="{standalone: true}">
        Department Head (can manage centre &amp; file access for peers in {{md.department || 'their department'}})
      </mat-checkbox>
    </div>
  </div>
  <div class="text-center">
    <label class="mx-5 font-bold ">User Role</label>
    <!--    <input type="text" placeholder="Enter Counsellor" class="border border-secondary rounded bg-white text-dark p-2 ms-5 w-50 ">-->
  </div>

  <table class="table mt-4 ">
    <!--    <thead  >-->
    <!--    <tr >-->
    <!--      <th class="head">Sections</th>-->
    <!--      <th class="head">All</th>-->
    <!--      <th class="head">Add</th>-->
    <!--      <th class="head">Edit</th>-->
    <!--      <th class="head">Archive</th>-->
    <!--      <th class="head">View</th>-->
    <!--      <th class="head">Excel</th>-->
    <!--      <th class="head">Menu</th>-->
    <!--    </tr>-->

    <!--    </thead>-->
    <br>
    <tbody>
      <ng-container *ngFor="let d of data; let i = index">
        <!--      <tr *ngIf="i === 0 || data[i - 1]?.group !== d.group" class="group-separator">-->

        <!--        <td colspan="9" class="text-center font-bold menu-header">-->
        <!--          {{ d.group || 'Ungrouped' }}-->
        <!--        </td>-->

        <!--      </tr>-->
        <tr *ngIf="i === 0 || data[i - 1]?.group !== d.group" class="group-separator">
          <td class="font-bold menu-header menu-header-section">{{ d.group || 'Ungrouped' }}</td>
          <td class="menu-header checkbox-label">
            <label style="cursor: pointer; margin: 0;">
              <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'all')" (change)="toggleGroupColumn(d.group, 'all', $event)">
              <span style="padding-left: 5px">All</span>
            </label>
          </td>
          <td class="menu-header checkbox-label">
            <label style="cursor: pointer; margin: 0;">
              <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'add')" (change)="toggleGroupColumn(d.group, 'add', $event)">
              <span style="padding-left: 5px">Add</span>
            </label>
          </td>
          <td class="menu-header checkbox-label">
            <label style="cursor: pointer; margin: 0;">
              <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'edit')" (change)="toggleGroupColumn(d.group, 'edit', $event)">
              <span style="padding-left: 5px">Edit</span>
            </label>
          </td>
          <td class="menu-header checkbox-label">
            <label style="cursor: pointer; margin: 0;">
              <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'archive')" (change)="toggleGroupColumn(d.group, 'archive', $event)">
              <span style="padding-left: 5px">Archive</span>
            </label>
          </td>
          <td class="menu-header checkbox-label">
            <label style="cursor: pointer; margin: 0;">
              <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'view')" (change)="toggleGroupColumn(d.group, 'view', $event)">
              <span style="padding-left: 5px">View</span>
            </label>
          </td>
          <td class="menu-header checkbox-label">
            <label style="cursor: pointer; margin: 0;">
              <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'excel')" (change)="toggleGroupColumn(d.group, 'excel', $event)">
              <span style="padding-left: 5px">Excel</span>
            </label>
          </td>
          <td class="menu-header checkbox-label">
            <label style="cursor: pointer; margin: 0;">
              <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'showMenu')" (change)="toggleGroupColumn(d.group, 'showMenu', $event)">
              <span style="padding-left: 5px">Menu</span>
            </label>
          </td>
        </tr>
        <tr>
          <td *ngIf="d.functionName!='Employee'">{{d.functionName}}
            <!--          <span *ngIf="d.group">({{d?.group}})</span>-->
          </td>
          <td *ngIf="d.functionName=='Employee'">Users</td>
          <td class="checkbox-label">
            <input type="checkbox" [(ngModel)]="d.all" (change)="selectAllCheckbox(d)">
            <span style="padding-left: 5px">All</span>
          </td>
          <td class="checkbox-label">
            <input type="checkbox" [(ngModel)]="d.add" (change)="updateAllCheckbox(d)">
            <span style="padding-left: 5px">Add</span>
          </td>
          <td class="checkbox-label">
            <input type="checkbox" [(ngModel)]="d.edit" (change)="updateAllCheckbox(d)">
            <span style="padding-left: 5px">Edit</span>
          </td>
          <td class="checkbox-label">
            <input type="checkbox" [(ngModel)]="d.archive" (change)="updateAllCheckbox(d)">
            <span style="padding-left: 5px">Archive</span>
          </td>
          <td class="checkbox-label">
            <input type="checkbox" [(ngModel)]="d.view" (change)="updateAllCheckbox(d)">
            <span style="padding-left: 5px">View</span>
          </td>
          <td class="checkbox-label">
            <input type="checkbox" [(ngModel)]="d.excel" (change)="updateAllCheckbox(d)">
            <span style="padding-left: 5px">Excel</span>
          </td>
          <td class="checkbox-label">
            <input type="checkbox" [(ngModel)]="d.showMenu" (change)="updateAllCheckbox(d)">
            <span style="padding-left: 5px">Menu</span>
          </td>

        </tr>
        <tr *ngIf="i < data.length - 1 && data[i]?.group !== data[i + 1]?.group" class="divider">
          <td colspan="9" class="border-top"></td>
        </tr>
      </ng-container>
    </tbody>

  </table>
  <div class="text-center">
    <button mat-raised-button class=" menu-header text-center bg-warning w-50 mt-4" (click)="submit()">Submit</button>
  </div>
  <hr>
  <!--<p>{{data|json}}</p>-->
  <!--  <prettyjson [obj]="selectedCentres"></prettyjson>-->
  <!--  <prettyjson [obj]="md.centresAllowed"></prettyjson>-->
</div>
